import React from "react";
import { Link } from "ui/Link";

export function Brand() {
    return (
        <Link to="/" onClick={() => window.scrollTo(0, 0)}>
            <img
                src={`/logo.png`}
                alt={"siteName"}
                style={{ height: 40, display: "block" }}
                onClick={() => window.scrollTo(0, 0)}
            />
        </Link>
    );
}
